import React from "react";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";

import { CButton, CModal, CModalBody } from "@coreui/react";

import { ConfirmModalProps } from "../../../models/user.model";

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title = COMMON_CONSTANTS.CONFIRM_DELETE_MESSAGE,
  children,
  confirmButtonText = COMMON_CONSTANTS.CONFIRM_BUTTON,
  cancelButtonText = COMMON_CONSTANTS.CANCEL_BUTTON,
  onConfirm,
  onCancel,
  isShow,
  isNeedCancelButton = COMMON_CONSTANTS.SHOW,
}) => {
  return (
    <div>
      <CModal visible={isShow} onClose={onCancel} backdrop="static">
        <CModalBody>
          <div className="app-row-padding">
            <div className="dd-confirm-title">
              <h6 className="st-confirm-title">{title}</h6>
            </div>
            {children ?? <></>}
            <div className="dd-confirm-cancel-btn mb-2">
              {isNeedCancelButton && (
                <CButton
                  className="st-cancel-btn me-2 float-start"
                  color="secondary"
                  onClick={() => {
                    onCancel();
                  }}
                >
                  {cancelButtonText}
                </CButton>
              )}
              <CButton
                className={`st-confirm-btn dd-login-button ${isNeedCancelButton ? "float-end" : "text-center mt-2"}`}
                onClick={() => {
                  onConfirm();
                }}
              >
                {confirmButtonText}
              </CButton>
            </div>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default ConfirmModal;
